// @ts-nocheck
import { replaceAllNotDigitsTextCursor } from '../replaceWithCursorPosition';

export class MaskPercents_v2 {
  public iconMask() {
    return '';
  }

  public removeMask(value: string, cursorPosition): { newValue; newCursorPosition } {
    let valueString: string = typeof value !== 'string' ? String(value) : value;
    if (valueString.length === 1 && valueString !== '0') {
      valueString = '00' + valueString;
      cursorPosition = 3;
    }
    const { newValue, newCursorPosition } = replaceAllNotDigitsTextCursor(
      valueString,
      cursorPosition
    );
    const distanceToFinal = newValue.length - newCursorPosition;

    let newValueFormated = newValue.replace(/(^[\d]+)(\d{2})/g, '$1.$2');
    let formatedCursorPosition = newValueFormated.length;

    let correction = 0;
    if (distanceToFinal >= 2) {
      correction += 1;
    }

    if (newValueFormated.length === 2 && newValueFormated !== '00') {
      newValueFormated = '00.' + newValueFormated;
    }

    formatedCursorPosition = newValueFormated.length - (distanceToFinal + correction);

    return { newValue: newValueFormated, newCursorPosition: formatedCursorPosition };
  }

  public setMask(value: string, cursorPosition): { formatedValue; formatedCursorPosition } {
    const valueString: string = typeof value !== 'string' ? String(value) : value;
    const { newValue, newCursorPosition } = replaceAllNotDigitsTextCursor(
      valueString,
      cursorPosition
    );
    if (!value) {
      return { formatedValue: '', formatedCursorPosition: 0 };
    }

    const distanceToFinal = newValue.length - newCursorPosition;
    let correction = 0;

    // tira zero a esqueda
    let newValueFormated = newValue.replace(/^[0]+/, '');
    // coloca virgula e porcentagem
    newValueFormated = newValueFormated.replace(/(^[\d]+)(\d{2})$/, '$1,$2%');
    // formata poucos digitos
    if (newValueFormated.length <= 2) {
      if (newValueFormated.length === 1) {
        newValueFormated = newValueFormated.replace(/(^[\d]{1,2}$)/, '0,0$1%');
      } else newValueFormated = newValueFormated.replace(/(^[\d]{1,2}$)/, '0,$1%');
    }

    let formatedCursorPosition = newValueFormated.length;

    if (distanceToFinal >= 2) {
      correction += 2;
    } else {
      correction += 1;
    }

    formatedCursorPosition = newValueFormated.length - (distanceToFinal + correction);

    return { formatedValue: newValueFormated, formatedCursorPosition };
  }
}
